var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-group',{attrs:{"label":_vm.label,"description":_vm.description,"label-class":_vm.labelClass,"use-label":_vm.useLabel,"use-horizontal":_vm.useHorizontal,"css-class":_vm.cssClass}},[_c('div',{staticClass:"mt-2"},[_c('span',{staticClass:"font-size-h4 font-weight-bolder text-dark"},[_vm._v(" "+_vm._s(_vm.model || "-")+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }